import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { UniversoAuditavelService } from "../../../../services/universo-auditavel.service";
import { SharedService } from "../../../../services/shared.service";

@Component({
	selector: 'app-modal-adicionar-nao-cadastrado',
	templateUrl: './modal-adicionar-nao-cadastrado.component.html',
	styleUrls: ['./modal-adicionar-nao-cadastrado.component.scss'],
})


export class ModalAdicionarNaoCadastradoComponent implements OnInit {

  novoItem: string = '';

	constructor(
		private router: Router,
		@Inject(MAT_DIALOG_DATA) public data: any,
		private universoAuditavelService: UniversoAuditavelService,
		private sharedService: SharedService,
		private dialogRef: MatDialogRef<ModalAdicionarNaoCadastradoComponent>
	) {}

	ngOnInit(): void {}

	cancelar(): void {
		this.dialogRef.close();
	}

	salvar(): void {
		this.dialogRef.close(this.novoItem);
	}
}
